import { render, staticRenderFns } from "./WarehouseRemainForm.vue?vue&type=template&id=21b0893f&"
import script from "./WarehouseRemainForm.vue?vue&type=script&lang=ts&"
export * from "./WarehouseRemainForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports